import { render, staticRenderFns } from "./Bye.vue?vue&type=template&id=c83765bc&scoped=true&"
import script from "./Bye.vue?vue&type=script&lang=js&"
export * from "./Bye.vue?vue&type=script&lang=js&"
import style0 from "./Bye.vue?vue&type=style&index=0&id=c83765bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83765bc",
  null
  
)

export default component.exports